__webpack_require__.p = "/wc/muuzbox/";